import backpack from '~/assets/icons/backpack_2.svg';
import barmor from '~/assets/icons/barmor.svg';
import bracelet from '~/assets/icons/bracelet.svg';
import earrings from '~/assets/icons/earrings.svg';
import glasses from '~/assets/icons/glasses.svg';
import hat from '~/assets/icons/hat.svg';
import jacket from '~/assets/icons/jacket.svg';
import mask from '~/assets/icons/mask.svg';
import necklace from '~/assets/icons/necklace.svg';
import pants from '~/assets/icons/pants.svg';
import sneakers from '~/assets/icons/sneakers.svg';
import suit from '~/assets/icons/suit.svg';
import watch from '~/assets/icons/watch.svg';
import { ClothesType, Item, ItemAction, ItemData, ItemType } from '~/shared';
import backpackImage from '../../assets/images/inventoryStub/backpack.png';
import backpackImage2 from '../../assets/images/inventoryStub/backpack2.png';
import bikeImage from '../../assets/images/inventoryStub/bike.png';
import fanPantsImage from '../../assets/images/inventoryStub/fanPants.png';
import fishImage from '../../assets/images/inventoryStub/fish.png';
import jeleImage from '../../assets/images/inventoryStub/jele.png';
import keysImage from '../../assets/images/inventoryStub/keys.png';
import shortsImage from '../../assets/images/inventoryStub/shorts.png';

export const INVENTORY_CELLS_COUNT = 20;

export const selectItems = [
	'По имени',
	'По количеству',
	'По типу',
	'По новизне',
];

// Стабы для тестирования
export const mockItems: (Omit<Item, 'id' | 'availableActions'> & {
	baseActions: ItemAction[];
	slots?: number;
})[] = [
	{
		itemId: 'pants',
		name: 'Шорты',
		subName: 'Essentials',
		count: 1,
		type: ItemType.CLOTHES,
		image: shortsImage,
		baseActions: [ItemAction.EQUIP],
		stackable: false,
		tags: [],
		data: {
			clothes: {
				type: ClothesType.PANTS,
			},
		},
	},
	{
		itemId: 'backpack-1',
		name: 'Рюкзак',
		subName: 'Tactical',
		count: 1,
		type: ItemType.BACKPACK,
		image: backpackImage,
		baseActions: [ItemAction.EQUIP],
		stackable: false,
		slots: 5,
		tags: [],
		data: {
			backpack: {
				inventoryId: 'backpack-1',
			},
			clothes: {
				type: ClothesType.BACKPACK,
			},
		},
	},
	{
		itemId: 'backpack-2',
		name: 'Рюкзак',
		subName: 'шпион',
		count: 1,
		type: ItemType.BACKPACK,
		image: backpackImage2,
		baseActions: [ItemAction.EQUIP, ItemAction.DROP],
		stackable: false,
		slots: 8,
		tags: [],
		data: {
			backpack: {
				inventoryId: 'backpack-2',
			},
			clothes: {
				type: ClothesType.BACKPACK,
			},
		},
	},
	{
		itemId: 'fish',
		name: 'Рыба',
		subName: 'Свежая',
		count: 5,
		type: ItemType.FOOD,
		image: fishImage,
		baseActions: [ItemAction.USE, ItemAction.DROP],
		stackable: true,
		tags: [],
	},
	{
		itemId: 'keys',
		name: 'Ключ',
		subName: 'от квартиры',
		count: 1,
		type: ItemType.OTHER,
		image: keysImage,
		baseActions: [ItemAction.USE],
		stackable: false,
		tags: [],
	},
	{
		itemId: 'jele',
		name: 'Желе',
		subName: 'квантовое',
		count: 4,
		type: ItemType.FOOD,
		image: jeleImage,
		baseActions: [ItemAction.USE, ItemAction.DROP],
		stackable: true,
		tags: [],
	},
	{
		itemId: 'bike',
		name: 'Велосипед',
		subName: 'летающий',
		count: 1,
		type: ItemType.OTHER,
		image: bikeImage,
		baseActions: [ItemAction.USE, ItemAction.DROP],
		stackable: false,
		hasUsageLimit: true,
		usageLimit: 10,
		usageLeft: 7,
		tags: [],
	},
	{
		itemId: 'fan-pants',
		name: 'Штаны',
		subName: 'с охлаждением',
		count: 1,
		type: ItemType.CLOTHES,
		image: fanPantsImage,
		baseActions: [ItemAction.EQUIP, ItemAction.DROP],
		stackable: false,
		hasUsageLimit: true,
		usageLimit: 10,
		usageLeft: 2,
		tags: [],
	},
];

export const clothesPlaceholders = [
	{
		placeholderImage: glasses,
		placeholderText: 'Очки',
		height: 1,
	},
	{
		placeholderImage: hat,
		placeholderText: 'Гол. убор',
		height: 1,
	},
	{
		placeholderImage: mask,
		placeholderText: 'Маска',
		height: 1,
	},
	{
		placeholderImage: earrings,
		placeholderText: 'Серьги',
		height: 1,
	},
	{
		placeholderImage: necklace,
		placeholderText: 'Акссесуар',
		height: 1,
	},
	{
		placeholderImage: barmor,
		placeholderText: 'Бронежилет',
		height: 1,
	},
	{
		placeholderImage: bracelet,
		placeholderText: 'Браслет',
		height: 1,
	},
	{
		placeholderImage: jacket,
		placeholderText: 'Верх',
		height: 1,
	},
	{
		placeholderImage: watch,
		placeholderText: 'Часы',
		height: 1,
	},
	{
		placeholderImage: suit,
		placeholderText: 'Костюм',
		height: 2,
	},
	{
		placeholderImage: pants,
		placeholderText: 'Штаны',
		height: 1,
	},
	{
		placeholderImage: backpack,
		placeholderText: 'Рюкзак',
		height: 2,
	},
	{
		placeholderImage: sneakers,
		placeholderText: 'Обувь',
		height: 1,
	},
];

export const getCharacterCellByItemType = (
	itemData?: ItemData,
): string | null => {
	if (!itemData) return null;

	const clothes: ClothesType | undefined = itemData?.clothes?.type;
	if (clothes === undefined) return null;

	switch (clothes) {
		case ClothesType.GLASSES:
			return 'char-1';
		case ClothesType.HAT:
			return 'char-2';
		case ClothesType.MASK:
			return 'char-3';
		case ClothesType.EARRINGS:
			return 'char-4';
		case ClothesType.ACCESSORY:
			return 'char-5';
		case ClothesType.ARMOR:
			return 'char-6';
		case ClothesType.BRACELET:
			return 'char-7';
		case ClothesType.TOP:
			return 'char-8';
		case ClothesType.WATCHES:
			return 'char-9';
		case ClothesType.SUIT:
			return 'char-10';
		case ClothesType.PANTS:
			return 'char-11';
		case ClothesType.BACKPACK:
			return 'char-12';
		case ClothesType.SHOES:
			return 'char-13';
		default:
			return null;
	}
};

export const getClothesTypeName = (clothesType: ClothesType): string => {
	switch (clothesType) {
		case ClothesType.GLASSES:
			return 'Очки';
		case ClothesType.EARRINGS:
			return 'Серьги';
		case ClothesType.BRACELET:
			return 'Браслет';
		case ClothesType.SUIT:
			return 'Костюм';
		case ClothesType.HAT:
			return 'Гол. убор';
		case ClothesType.TOP:
			return 'Верх';
		case ClothesType.PANTS:
			return 'Штаны';
		case ClothesType.SHOES:
			return 'Обувь';
		case ClothesType.MASK:
			return 'Маска';
		case ClothesType.ARMOR:
			return 'Бронежилет';
		case ClothesType.WATCHES:
			return 'Часы';
		case ClothesType.BACKPACK:
			return 'Рюкзак';
		case ClothesType.ACCESSORY:
			return 'Акссесуар';
	}
};
